import { downLoadFile } from '@utils'

const extensionsByMimeType: Partial<Record<string, string>> = {
  'application/pdf': 'pdf',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
  'image/png': 'png',
  'image/jpeg': 'jpg',
}

/**
 * Saves a customer file (e.g. a custom plan or documentation template) under its name. The signed
 * url points at the storage key (the file guid) and is cross-origin, where `<a download>` is
 * ignored, so the file is fetched as a blob first and saved with its name and extension.
 */
const downloadCustomerFile = async (file: CustomerFile): Promise<void> => {
  if (!file.url) throw new Error('Customer file has no download url')

  const response = await fetch(file.url)
  if (!response.ok) throw new Error('Customer file download failed')

  const extension = extensionsByMimeType[file.mimetype]
  const hasExtension = !!extension && file.name.toLowerCase().endsWith(`.${extension}`)
  const fileName = extension && !hasExtension ? `${file.name}.${extension}` : file.name

  downLoadFile(await response.blob(), file.mimetype as BlobType, fileName)
}

export default downloadCustomerFile
